import { useEffect, useRef, useState } from 'react';

// Préparer les messages proches du panneau avant qu'une action devienne visible.
export const WallMessageFrame = ({ deferred, estimatedHeight, children, ...props }) => {
    const ref = useRef(null);
    const [near, setNear] = useState(!deferred);
    useEffect(() => {
        if (!deferred) return;
        const observer = new IntersectionObserver(([entry]) => setNear(entry.isIntersecting), {
            root: ref.current.parentElement, rootMargin: '600px 0px',
        });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [deferred]);
    return <div ref={ref} {...props} style={deferred && !near ? {
        contentVisibility: 'auto', containIntrinsicSize: `auto ${estimatedHeight}px`,
    } : undefined}>{children}</div>;
};